var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-card',[_c('vs-tabs',{attrs:{"color":_vm.colorx}},[_c('vs-tab',{attrs:{"label":"Visitas","icon":"event"},on:{"click":function($event){_vm.colorx = '#ECAF2B'}}},[_c('visitas',{attrs:{"tipo":"1","valor":"Visita"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }